var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon_comment"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 16",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.00819 15.1212H14.7236C15.3007 15.1212 15.7972 14.9108 16.2117 14.4901C16.6256 14.0701 16.8328 13.5754 16.8328 13.0061V3.76596C16.8328 3.19732 16.6256 2.70196 16.2117 2.28125C15.7972 1.86121 15.3007 1.65018 14.7236 1.65018H3.27567C2.69862 1.65018 2.20283 1.86121 1.78829 2.28125C1.37445 2.70196 1.16718 3.19732 1.16718 3.76596V17.4222L5.00819 15.1212ZM17.0401 1.46493C17.6798 2.10821 18 2.88789 18 3.80261V12.9688C18 13.8848 17.6798 14.6638 17.0401 15.3064C16.3997 15.9504 15.6278 16.2714 14.7236 16.2714H5.3091L0 19.5V3.80261C0 2.88789 0.31951 2.10821 0.959908 1.46493C1.60031 0.822321 2.37223 0.5 3.27567 0.5H14.7236C15.6278 0.5 16.3997 0.822321 17.0401 1.46493Z",
  fill: "black"
}))));
export default SvgComment;